import { IconButton, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React from 'react'
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import MuiTable from "@material-ui/core/Table";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import { Cell, useSortBy, useTable } from 'react-table';
import { TravelerModal } from '../../../common/travelerModal';

export const BomDetailsTable = ({ data }: any) => {
    const columns = React.useMemo(
        () => [
            {
                Header: "Id",
                accessor: "id",
            },

            {
                Header: "Serial Number",
                accessor: "serial_number",
                Cell: ({ value }:any) => (
                    <div style={{ textAlign: "center" }}>{value}</div>
                ),
            },

            {
                Header: "Type",
                accessor: "unit_type",
                Cell: ({ value }:any) => (
                    <div style={{ textAlign: "center" }}>{value}</div>
                ),
            },
            {
                Header: "Assigned Test Sequence",
                accessor: "assigned_test_sequence_name",
                Cell: ({ value }:any) => (
                    <div style={{ textAlign: "center" }}>{value}</div>
                ),
            },
        ],
        []
    );

    const {
        getTableProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable(
        {
            data: data,
            columns,
            initialState: {
                hiddenColumns: ["id"],
            },
        },
        useSortBy,
    );
    const renderCell = (cell: Cell<object, any>) => {
        if (cell.column.Header === "Serial Number") {
            return <TravelerModal serialNumber={cell.value} />;
        } else {
            return cell.render("Cell");
        }
    }
    return (

        <>
            <TableContainer
                data-testid="tableContainer"
                component={Paper}
                style={{ maxHeight: 440 , marginBottom: 30}}
            >
                <MuiTable {...getTableProps()} stickyHeader size="small">
                    <TableHead>
                        {headerGroups.map((headerGroup) => (
                            <TableRow {...headerGroup.getHeaderGroupProps()} style={{ height: 60 }}>
                                {headerGroup.headers.map((column) => (
                                    <TableCell {...column.getHeaderProps()} align="center"  >
                                        {column.render("Header")}
                                        <IconButton
                                            type="submit"
                                            aria-label="search"
                                            size="small"
                                            {...column.getSortByToggleProps()}
                                        >
                                            {column.isSorted ? (
                                                column.isSortedDesc ? (
                                                    <ArrowDropDownIcon />
                                                ) : (
                                                    <ArrowDropUpIcon />
                                                )
                                            ) : (
                                                column.id !== "selection" && <CallSplitIcon />
                                            )}
                                        </IconButton>
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            prepareRow(row);
                            return (
                                <TableRow
                                    {...row.getRowProps()}
                                    style={{ height: 60 }}
                                >
                                    {row.cells.map((cell) => {
                                        return (
                                            <TableCell {...cell.getCellProps()}
                                            // style={{ padding: "16px 8px" }}
                                            >
                                                {renderCell(cell)}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </MuiTable>
            </TableContainer>

        </>
    )
}

